// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dharma-back-dbxy.onrender.com/",
});

export default axiosInstance;

// export const weburl = "http://localhost:3050/";
export const weburl = "https://dharma-back-dbxy.onrender.com/";

export const shopurl = "https://adminfitamigo.spacedeco.in/";
export const mainurl = "https://fitamigo.spacedeco.in/";
export const fronturl = "https://adminfitamigo.spacedeco.in/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;